import { Link } from '@tanstack/react-router';
import { Clock } from 'lucide-react';
import type { Case } from '@casetrace/shared';
import { StatusBadge } from '../../components/ui/badge';

function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('nb-NO', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(new Date(iso));
}

interface CaseCardProps {
  caseItem: Case;
}

export function CaseCard({ caseItem }: CaseCardProps) {
  return (
    <Link
      to="/cases/$caseId"
      params={{ caseId: caseItem.id }}
      className="group block rounded-lg border p-4 transition-colors duration-150 hover:border-white/[0.14]"
      style={{
        background: 'var(--color-surface)',
        borderColor: 'rgba(255,255,255,0.07)',
      }}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 overflow-hidden">
          <h3 className="truncate text-sm font-medium text-[#ededf0] group-hover:text-white">
            {caseItem.navn}
          </h3>
          <p className="mt-0.5 text-xs text-[#5e6070]">
            {caseItem.saksnummer} · {caseItem.klient}
          </p>
        </div>
        <StatusBadge status={caseItem.status} />
      </div>
      <div className="mt-3 flex items-center gap-1.5 text-xs text-[#5e6070]">
        <Clock size={11} />
        <span>{formatDate(caseItem.updatedAt)}</span>
      </div>
    </Link>
  );
}
